import '@angular/compiler';
export * from './lib/gvp-core-components.module';
